import get from 'lodash/fp/get';
import trimEnd from 'lodash/trimEnd';
import { createSelector } from 'reselect';
import defaultRedirects from 'config/redirects';
import getMatch from './getMatch';

/**
 * @typedef {object} Redirect
 * @property {string|RegExp} pattern
 * @property {string} replace
 *
 * Select dynamic redirects from state, map them to Redirect objects,
 * then concat and return with static Redirect objects.
 * @return {Redirect[]}
 */
export const getRedirects = createSelector(
  [get('redirect')],
  (redirectMap) => Object
    .keys(redirectMap)
    .map((pattern) => ({ pattern, replace: redirectMap[pattern] }))
    .concat(defaultRedirects),
);

/**
 * Find the first redirect pattern that matches the current url path,
 * and return the new url to redirect to.
 * @return {string}
 */
const getRedirect = createSelector(
  [getRedirects, getMatch],
  (redirects, { url }) => {
    const redirect = redirects.find(({ pattern }) => (
      pattern instanceof RegExp ?
        url.match(pattern) :
        trimEnd(url, '/') === trimEnd(pattern, '/')
    ));
    if (!redirect) {
      return undefined;
    }

    const { pattern, replace } = redirect;
    const replacedString = url.replace(pattern, replace);
    if (!replacedString) {
      return undefined;
    }
    return replacedString;
  },
);

export default getRedirect;
